import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Modal, ModalBody, CardBody, InputGroup, Dropdown, DropdownButton, Alert, Spinner, OverlayTrigger, Tooltip} from "react-bootstrap";
import { FaSearch, FaEraser, FaFileExcel, FaFilePdf, FaEye, FaPencilAlt, FaCheck, FaTimes, FaFileDownload, FaPaperPlane, FaExclamationCircle, FaUpload } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, getCurrentUser, tiposAcesso, formataDataExibicao, extrairDataDatetime, tiposSessoesCampos } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import Paginacao from '../../common/pagination';
import withReactContent from 'sweetalert2-react-content'
import { IMaskInput } from 'react-imask';

class Farmacovigilancia extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);
        this.fileInput = React.createRef();

        this.state = {
            listRegistros: [],
            error: "",
            loading: true,
            loadingBotao: false,
            filtro_status: false,
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',

            paciente_nome: '',
            filtro_usuario_relato_id: '',
            filtro_usuario_relato_nome: '',
            filtro_doenca_id: '',
            filtro_doenca_nome: '',
            codigo_externo: '',
            programa_select_key: 0,
            programa_dados: {},
            showModalRelato: false,
            showModalUploadFarmaco: false,
            valoresRelato: null,
            showModalHistorico: false,
            historicoEnvios: [],
            historicoLoading: false,
            arquivo_upload: '',
            dados_modal_upload: {},
            
            atendimentoCache: {},        // { [uuid]: dadosDoAtendimento }
            atendimentoLoading: new Set(),// evita requisições duplicadas
            editingCampoValues: {},   
            campoEditadoValores: {},  
            updatingCampoValues: {},
            campoMetaById: {},
            idClientePendente: {},  // { [relato_id]: { ano: '24', numero: '123456' } }
        };
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1,
                filtro_status: false,
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                filtro_status: false,
            }), () => {
                this.carregaDadosPrograma(this.state.filtro_programa_id);
            });
        }
        else if(fieldName == 'doenca_id') {
            this.setState(prevState => ({
                filtro_doenca_id: event.value, 
                filtro_doenca_nome: event.label,
                filtro_status: false,
            }));
        }
        else if(fieldName == 'usuario_relato_nome') {
            this.setState(prevState => ({
                filtro_usuario_relato_id: event.value, 
                filtro_usuario_relato_nome: event.label,
                filtro_status: false,
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value, filtro_status: false });
        }
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    // helper: pega único por uuid da lista atual
    getUuidsDaLista = () => {
        if (!('results' in this.state.listRegistros)) return [];
        const uuids = this.state.listRegistros.results
            .map(r => r?.dados_atendimento?.uuid)
            .filter(Boolean);
        return Array.from(new Set(uuids));
    };
    
    carregaDoencas = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        try {
            const programa_id = dados_usuario['ambiente_programa_id'] || this.state.filtro_programa_id;
            if(programa_id) {
                const response = await api.get(`/programas/doencas/?programa_id=${programa_id}&nome=${inputValue}`);
                const opcoes = response.data.results.map(doenca => ({
                    value: doenca.dados_doenca.id,
                    label: doenca.dados_doenca.nome
                }));
                return opcoes;
            } else {
                const response = await api.get(`/doencas/?nome=${inputValue}`);
                const opcoes = response.data.results.map(doenca => ({
                    value: doenca.id,
                    label: doenca.nome
                }));
                return opcoes;
            }
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };

    carregaNavegadora = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        const programa_id = dados_usuario['ambiente_programa_id'] || this.state.filtro_programa_id;
        try {
            const response = await api.get(`/pessoas/operadores/?nome=${inputValue}&programa_id=${programa_id}`);
            const opcoes = response.data.results.map(navegadora => ({
                value: navegadora.id,
                label: navegadora.dados_pessoa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar navegadora:', error);
            return [];
        }
    };

    componentDidMount(){
        let startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        let endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        let dados_usuario = getCurrentUser();
        const cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : '';
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        if(programa_id) {
            this.carregaDadosPrograma(programa_id);
        }

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_cliente_id: cliente_id,
            filtro_programa_id: programa_id,
            
            paciente_nome: this.state.paciente_nome,
            filtro_usuario_relato_id: this.state.filtro_usuario_relato_id,
            filtro_doenca_id: this.state.filtro_doenca_id,
            codigo_externo: this.state.codigo_externo,
            loading: false
        }, () => {
            this.consultaRegistro();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.listRegistros !== this.state.listRegistros) {
            this.prefetchAtendimentos();
        }
    }

    // busca em lote (Promise.all) os que faltam
    prefetchAtendimentos = async () => {
        const { atendimentoCache, atendimentoLoading } = this.state;
        const uuids = this.getUuidsDaLista()
            .filter(uuid => !atendimentoCache[uuid] && !atendimentoLoading.has(uuid));

        if (uuids.length === 0) return;

        // marca como "loading" para evitar duplicadas
        const loadingSet = new Set(atendimentoLoading);
        uuids.forEach(u => loadingSet.add(u));
        this.setState({ atendimentoLoading: loadingSet });

        try {
            // se sua API tiver endpoint em lote, use-o aqui.
            // Como você pediu /atendimentos/{uuid}, fazemos individual:
            const respostas = await Promise.all(
            uuids.map(async (uuid) => {
                const resp = await api.get(`/atendimentos/${uuid}`);
                return { uuid, data: resp.data };
            })
            );

            const novoCache = { ...this.state.atendimentoCache };
            respostas.forEach(({ uuid, data }) => { novoCache[uuid] = data; });

            // limpa os "loading" recém carregados
            uuids.forEach(u => loadingSet.delete(u));

            this.setState({
            atendimentoCache: novoCache,
            atendimentoLoading: loadingSet
            });
        } catch (e) {
            // mesmo em erro, tira do loading para permitir tentar novamente (se você quiser)
            uuids.forEach(u => loadingSet.delete(u));
            this.setState({ atendimentoLoading: loadingSet });
            // opcional: logar/avisar
            // console.error('Falha ao buscar atendimentos', e);
        }
    };

    // fallback sob demanda (se preferir carregar só quando renderizar uma linha específica)
    carregaAtendimentoSePrecisar = async (uuid) => {
        const { atendimentoCache, atendimentoLoading } = this.state;
        if (!uuid || atendimentoCache[uuid] || atendimentoLoading.has(uuid)) return;

        const loadingSet = new Set(atendimentoLoading).add(uuid);
        this.setState({ atendimentoLoading: loadingSet });
        try {
            const resp = await api.get(`/atendimentos/${uuid}`);
            this.setState(prev => ({
            atendimentoCache: { ...prev.atendimentoCache, [uuid]: resp.data },
            atendimentoLoading: new Set([...prev.atendimentoLoading].filter(x => x !== uuid))
            }));
        } catch (e) {
            this.setState(prev => ({
            atendimentoLoading: new Set([...prev.atendimentoLoading].filter(x => x !== uuid))
            }));
        }
    };

    carregaDadosPrograma = (programa_id) => {
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ programa_dados: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                });
        }
    };


    consultaRegistro(){     
        
        //verifica se precisa de filtro de programa
        
        let filtros = '?farmacovigilancia=1'; 
    
        if(this.state.filtro_data_inicio){
            filtros += `&data_inicio=${this.state.filtro_data_inicio}`;
        }
    
        if(this.state.filtro_data_fim){
            filtros += `&data_fim=${this.state.filtro_data_fim}`;
        }
        
        if(this.state.filtro_programa_id){
            filtros += `&programa_id=${this.state.filtro_programa_id}`;
        }

        if(this.state.paciente_nome){
            filtros += `&paciente_nome=${this.state.paciente_nome}`;
        }

        if(this.state.filtro_usuario_relato_nome){
            filtros += `&usuario_relato_nome=${this.state.filtro_usuario_relato_nome}`;
        }

        if(this.state.filtro_doenca_id){
            filtros += `&doenca_id=${this.state.filtro_doenca_id}`;
        }

        if(this.state.codigo_externo){
            filtros += `&codigo_externo=${this.state.codigo_externo}`;
        }
    
        api.get(`/atendimentos/relatos/${filtros}`)
        .then(response => {
            const dados = response.data;
            this.setState({
                loading: false,
                error: "",
                listRegistros: dados,
                filtro_status: true
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar os relatos, tente novamente.';
            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }
            this.setState({
                loading: false,
                error: erro_msg,
                filtro_status: true
            });
        });
    }

    onChangeAlteraDataEnvio = (e, relato_id) => {        
        const payload = {
            'farmacovigilancia_data_envio': e.target.value
        }

        Swal.fire({
            title: 'Salvando...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Envia a requisição PUT para atualizar o relato
        api.put(`/atendimentos/relatos/${relato_id}/`, payload)
        .then((response) => {
            const updated = response.data;

            this.setState(prevState => ({
                listRegistros: {
                    ...prevState.listRegistros,
                    results: prevState.listRegistros.results.map(item =>
                    item.id === updated.id
                        ? updated   // objeto completo novo
                        : item              // mantém os demais
                    ),
                },
            }));

            // Fecha o loading e exibe o alerta de sucesso
            Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Registro atualizado com sucesso.",
            });
        })
        .catch((error) => {
            console.error("Erro ao atualizar relato:", error);
            // Fecha o loading e exibe o alerta de erro
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Não foi possível atualizar o regitro. Tente novamente.",
            });
        });
    };

    onChangeAlteraDataRelato = (e, relato_id, formulario_campo_id) => {        
        let payload;

        if (formulario_campo_id) {
            // Tem formulario_campo_id — atualiza via valores
            payload = {
                'valores': [
                    {
                        "formulario_campo_id": formulario_campo_id,
                        "valor": e.target.value
                    }
                ]
            };
        } else {
            // Não tem formulario_campo_id (data vem de item.data) — atualiza o campo data do relato
            payload = {
                'data': e.target.value
            };
        }

        Swal.fire({
            title: 'Salvando...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Envia a requisição PUT para atualizar o relato
        api.put(`/atendimentos/relatos/${relato_id}/`, payload)
        .then((response) => {
            const updated = response.data;

            this.setState(prevState => ({
                listRegistros: {
                    ...prevState.listRegistros,
                    results: prevState.listRegistros.results.map(item =>
                    item.id === updated.id
                        ? updated   // objeto completo novo
                        : item              // mantém os demais
                    ),
                },
            }));

            // Fecha o loading e exibe o alerta de sucesso
            Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Registro atualizado com sucesso.",
            });
        })
        .catch((error) => {
            console.error("Erro ao atualizar relato:", error);
            // Fecha o loading e exibe o alerta de erro
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Não foi possível atualizar o regitro. Tente novamente.",
            });
        });
    };

    uplPdfFarmaco = (e) => {
        e.preventDefault();

        Swal.fire({
            title: 'Você tem certeza?',
            text: `Deseja realmente substituir o arquivo PDF de farmacovigilancia do relato #${this.state.dados_modal_upload.relato_id}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                // Mostra alerta de carregamento
                Swal.fire({
                    title: 'Enviando arquivo...',
                    text: 'Por favor, aguarde enquanto o arquivo é enviado.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                
                // Primeiro, salvar o relato
                this.setState({loading:true})
                
                let formData = new FormData();
                formData.append('farmacovigilancia_pdf', this.state.arquivo_upload);                

                //envia a requisição
                api.put(`/atendimentos/relatos/${this.state.dados_modal_upload.relato_id}/`, formData)
                .then(response => {                    
                    const updated = response.data;
                    this.setState({loading:false})

                    Swal.fire({
                        title: 'Sucesso!',
                        text: 'PDF enviado com sucesso.',
                        icon: 'success'
                    }).then((result) => {
                        if (result.isConfirmed || result.dismiss) {                                                                                                  
                            this.setState(prevState => ({
                                listRegistros: {
                                    ...prevState.listRegistros,
                                    results: prevState.listRegistros.results.map(item =>
                                    item.id === updated.id
                                        ? updated   // objeto completo novo
                                        : item              // mantém os demais
                                    ),
                                },
                            }));

                            this.handleCloseModalUploadFarmaco()   
                        }
                    });
                })
                .catch(error => {
                    this.setState({loading:false})
                    console.error('Erro ao salvar o PDF:', error);
                    Swal.fire('Erro!', 'Não foi possível salvar o PDF.', 'error');
                });  
            }
        });                        
    };

    onChangeAlteraIDcliente = (e, relato_id) => {        
        const payload = {
            'farmacovigilancia_id_cliente': e.target.value
        }

        Swal.fire({
            title: 'Salvando...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Envia a requisição PUT para atualizar o relato
        api.put(`/atendimentos/relatos/${relato_id}/`, payload)
        .then((response) => {
            const updated = response.data;

            this.setState(prevState => ({
                listRegistros: {
                    ...prevState.listRegistros,
                    results: prevState.listRegistros.results.map(item =>
                    item.id === updated.id
                        ? updated   // objeto completo novo
                        : item              // mantém os demais
                    ),
                },
            }));

            // Fecha o loading e exibe o alerta de sucesso
            Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "O relato foi atualizado com sucesso.",
            });
        })
        .catch((error) => {
            console.error("Erro ao atualizar relato:", error);
            // Fecha o loading e exibe o alerta de erro
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Não foi possível atualizar o relato. Tente novamente.",
            });
        });
    };

    onlyDigits = (v) => 
        String(v || '').replace(/\D+/g, '');

    handlePermissaoCliente = (item, dados_usuario) => {
        const preenchido = !!(item.farmacovigilancia_id_cliente && item.farmacovigilancia_id_cliente.trim() !== '');

        const u = dados_usuario || {};
        
        const acesso = u.tipo_usuario === '' || u.tipo_usuario === 'gestor' || !!u.is_superuser;
            return !preenchido || acesso;
    };

    handleIdClienteAnoChange = (val, relatoId, anoOriginal) => {
        const ano = String(val || '');
        this.setState(prev => ({
            idClientePendente: {
                ...prev.idClientePendente,
                [relatoId]: {
                    ...prev.idClientePendente[relatoId],
                    ano,
                    anoOriginal: prev.idClientePendente[relatoId]?.anoOriginal ?? anoOriginal,
                }
            }
        }));
    };

    handleIdClienteNumeroChange = (val, relatoId, numeroOriginal) => {
        const numero = String(val || '');
        this.setState(prev => ({
            idClientePendente: {
                ...prev.idClientePendente,
                [relatoId]: {
                    ...prev.idClientePendente[relatoId],
                    numero,
                    numeroOriginal: prev.idClientePendente[relatoId]?.numeroOriginal ?? numeroOriginal,
                }
            }
        }));
    };

    handleIdClienteConfirm = (relatoId, anoAtualDB, numeroAtualDB) => {
        const pendente = this.state.idClientePendente[relatoId];
        if (!pendente) return;

        const ano = pendente.ano ?? anoAtualDB;
        const numero = pendente.numero ?? numeroAtualDB;

        // Valida: ano deve ter 2 dígitos, número deve ter 5-7 dígitos
        const anoDigits = this.onlyDigits(ano);
        const numDigits = this.onlyDigits(numero);

        if (anoDigits.length !== 2) {
            Swal.fire({ icon: 'warning', title: 'Atenção', text: 'O campo "ano" deve conter 2 dígitos.' });
            return;
        }
        if (numDigits.length < 5 || numDigits.length > 7) {
            Swal.fire({ icon: 'warning', title: 'Atenção', text: 'O campo "número" deve conter entre 5 e 7 dígitos.' });
            return;
        }

        const full = this.buildIdClienteFull(anoDigits, numDigits);
        this.onChangeAlteraIDcliente({ target: { value: full } }, relatoId);

        // Limpa o pendente após salvar
        this.setState(prev => {
            const copy = { ...prev.idClientePendente };
            delete copy[relatoId];
            return { idClientePendente: copy };
        });
    };

    handleIdClienteCancel = (relatoId) => {
        this.setState(prev => {
            const copy = { ...prev.idClientePendente };
            delete copy[relatoId];
            return { idClientePendente: copy };
        });
    };

    hasIdClientePendingChanges = (relatoId, anoAtualDB, numeroAtualDB) => {
        const pendente = this.state.idClientePendente[relatoId];
        if (!pendente) return false;
        const anoChanged = pendente.ano !== undefined && pendente.ano !== anoAtualDB;
        const numChanged = pendente.numero !== undefined && pendente.numero !== this.onlyDigits(numeroAtualDB);
        return anoChanged || numChanged;
    };


    getIdClienteAno = (fullValue) => {
        const m = /^BR-UGX-(\d{2})-/i.exec(fullValue || '');
        return m ? m[1] : new Date().getFullYear().toString().slice(-2);
        };

    getIdClienteNumero = (fullValue) => {
        const m = /^BR-UGX-\d{2}-(.*)$/i.exec(fullValue || '');
        return m ? (m[1] || '').replace(/\D/g, '') : '';
    };

    buildIdClienteFull = (yy, digits) => {
        const ano = (yy || '').replace(/\D/g, '').slice(0, 2);
        const num = (digits || '').replace(/\D/g, '');
        return `BR-UGX-${ano}-${num}`;
    };

    renderRows = () => {
        if(!this.state.filtro_status) {
            return (
                <tr>
                    <td colSpan={5}>Realize um filtro acima para exibir resultados</td>
                </tr>
            );
        }

        const {programa_dados} = this.state;
        
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {

            if (programa_dados?.farmacovigilancia_modelo === 'ache') {
                return this.state.listRegistros.results.map((item) => {

                    const dataRelato = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "data-relato"
                    )?.valor || null; 

                    const protocoloAtendimento = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "numero-de-protocolo"
                    )?.valor || '-';

                    return (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.dados_cadastrado_por.nome} {item.dados_cadastrado_por.sobrenome}</td>
                            <td>{dataRelato ? formataDataExibicao(dataRelato) : '-'}</td>
                            <td>{item.farmacovigilancia_data_envio ? formataDataHoraExibicao(item.farmacovigilancia_data_envio) : '-'}</td>
                            <td>{item.dados_atendimento.produto_descricao}</td>
                            <td>{protocoloAtendimento}</td>
                            <td>
                                {item.dados_atendimento.programa.farmacovigilancia_habilitar_pdf && (
                                    <>
                                    {item.farmacovigilancia_pdf ? (
                                        <a href={item.farmacovigilancia_pdf} target="_blank" className="btn btn-sm btn-secondary" rel="noopener noreferrer">
                                            <FaFilePdf /> Ver PDF
                                        </a>
                                    ) : (
                                    <Button 
                                        variant="light" 
                                        size="sm" 
                                        onClick={() => this.gerarPDF(item.id)}
                                    >
                                        <FaFilePdf /> Gerar PDF
                                    </Button>
                                    )}
                                    </>
                                )}
                            </td>
                        </tr>
                    )
                });
            } else if (programa_dados?.farmacovigilancia_modelo === 'psp_compass') {
                return this.state.listRegistros.results.map((item) => {

                    const campoDataRelatoQC = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "assinatura-data-relato-qc"
                    );

                    const campoDataRelato = campoDataRelatoQC || item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "data-do-relato"
                    );

                    const dataRelato = campoDataRelato?.valor || item.data;
                    const dataRelatoId = campoDataRelato?.formulario_campo_id || null;  

                    const iniciaisPaciente = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "iniciais"
                    )?.valor || null; 

                    const numeroRelato = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "n-relato-nss"
                    )?.valor || item.id;

                    return (
                        <tr key={item.id}>
                            <td>{numeroRelato}</td>
                            <td><a href={`/atendimentos/edit/${item.dados_atendimento.uuid}`} target="_blank">{item.atendimento_id}</a></td>
                            <td>
                                <Form.Control
                                    type="text"
                                    name="farmacovigilancia_id_cliente"
                                    defaultValue={item.farmacovigilancia_id_cliente}
                                    onBlur={e => this.onChangeAlteraIDcliente(e, item.id)}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="date"
                                    name="data_relato"
                                    defaultValue={extrairDataDatetime(dataRelato)}
                                    onBlur={e => this.onChangeAlteraDataRelato(e, item.id, dataRelatoId)}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="date"
                                    name="data_envio"
                                    defaultValue={extrairDataDatetime(item.farmacovigilancia_data_envio)}
                                    onBlur={e => this.onChangeAlteraDataEnvio(e, item.id)}
                                />
                            </td>
                            <td>{item.dados_atendimento.produto_descricao}</td>
                            <td>{iniciaisPaciente}</td>
                            <td>
                                {item.dados_atendimento.programa.farmacovigilancia_habilitar_pdf && (
                                    <>
                                    {item.farmacovigilancia_pdf ? (
                                        <>                                            
                                            <a href={item.farmacovigilancia_pdf} target="_blank" className="btn btn-sm btn-secondary mb-2" rel="noopener noreferrer">
                                                <FaFilePdf /> Ver PDF
                                            </a>

                                            {
                                            //botao para ver pdf assinado
                                            (item.letssign_pdf_farmaco_documento_assinado) &&
                                            <a href={item.letssign_pdf_farmaco_documento_assinado} target="_blank" className="btn btn-sm btn-secondary mb-2" rel="noopener noreferrer">
                                                <FaFilePdf /> Ver PDF assinado
                                            </a>
                                            }

                                            {
                                            //botão para assinar
                                            (!item.letssign_pdf_farmaco_documento_assinado) &&
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                className="mb-2"
                                                onClick={() => this.handleAssinarPDFFarmaco(item)}
                                            >
                                                <FaFilePdf /> Assinar
                                            </Button>
                                            }

                                            {
                                            //tooltip para exibir um erro na assinatura
                                            (item.letssign_pdf_farmaco && item.letssign_pdf_farmaco.erro) &&
                                            <OverlayTrigger
                                                placement="left"
                                                trigger={['hover', 'focus']}
                                                delay={{ show: 250, hide: 150 }}
                                                overlay={<Tooltip id="tip-erro">Assinatura: {item.letssign_pdf_farmaco.erro}</Tooltip>}
                                                >
                                                <span
                                                    className="d-inline-block"
                                                    tabIndex={0}
                                                    style={{ cursor: 'help' }}
                                                >
                                                    <FaExclamationCircle className="text-danger" size={20} />
                                                </span>
                                            </OverlayTrigger>
                                            }

                                            {
                                            //tooltip para exibir que a assinatura esta em andamento
                                            (item.letssign_pdf_farmaco && !item.letssign_pdf_farmaco.erro && !item.letssign_pdf_farmaco_documento_assinado) &&
                                            <OverlayTrigger
                                                placement="left"
                                                trigger={['hover', 'focus']}
                                                delay={{ show: 250, hide: 150 }}
                                                overlay={<Tooltip id="tip-info">A assinatura do documento está em andamento!</Tooltip>}
                                                >
                                                <span
                                                    className="d-inline-block"
                                                    tabIndex={0}
                                                    style={{ cursor: 'help' }}
                                                >
                                                    <FaExclamationCircle className="text-info" size={20} />
                                                </span>
                                            </OverlayTrigger>
                                            }

                                            {
                                            //botao para ver pdf assinado
                                            (!item.letssign_pdf_farmaco_documento_assinado) &&
                                            <Button variant="outline-secondary" size="sm" onClick={() => this.handleShowModalUploadFarmaco (item)}>
                                                <FaUpload/>
                                            </Button>
                                            }                                            
                                        </>
                                    ) : (
                                    <Button 
                                        variant="light" 
                                        size="sm" 
                                        className="mb-2"
                                        onClick={() => this.gerarPDF(item.id)}
                                    >
                                        <FaFilePdf /> Gerar PDF
                                    </Button>
                                    )}
                                    </>
                                )}
                            </td>
                            <td>
                                <Button variant="outline-secondary" size="sm" onClick={() => this.handleShowModalRelato (item)}>
                                    <FaEye/>
                                </Button>
                            </td>
                        </tr>
                    )
                });
            } else if (programa_dados?.farmacovigilancia_modelo === 'ultracare') {
                return this.state.listRegistros.results.map((item) => {

                    const uuid = item?.dados_atendimento?.uuid;
                    const atend = uuid ? this.state.atendimentoCache[uuid] : null;
                    const dados_usuario = getCurrentUser();

                    if (uuid && !atend) this.carregaAtendimentoSePrecisar(uuid);

                    const nomePaciente = atend?.dados_beneficiario?.nome || item.dados_atendimento?.nome_paciente || '-';

                    const dataRelato = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "assinatura-data-relato-qc"
                    )?.valor || item.data; 

                    const iniciaisPaciente = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "iniciais"
                    )?.valor || null; 

                    const numeroRelato = item.valores_list.find(
                        (valor) => valor.formulario_campo__slug === "n-relato-nss"
                    )?.valor || item.id;

                    return (
                        <tr key={item.id}>
                            <td>{item.id}</td>

                            <td>{nomePaciente}</td>
                            <td>{item.dados_atendimento.doenca?.nome}</td>
                            
                            <td>
                                {(() => {
                                const ano = this.getIdClienteAno(item.farmacovigilancia_id_cliente);
                                const numero = this.getIdClienteNumero(item.farmacovigilancia_id_cliente);
                                const canEdit = this.handlePermissaoCliente(item, dados_usuario);
                                const hasPending = this.hasIdClientePendingChanges(item.id, ano, numero);
                                const pendente = this.state.idClientePendente[item.id];

                                return (
                                    <InputGroup size="sm">
                                    <InputGroup.Text>BR-UGX-</InputGroup.Text>

                                    <Form.Control
                                        as={IMaskInput}
                                        mask="00"
                                        lazy={false}
                                        unmask="typed"
                                        key={`ano-${item.id}-${ano}`}
                                        defaultValue={pendente?.ano ?? ano}
                                        inputMode="numeric"
                                        disabled={!canEdit}
                                        style={{ maxWidth: 60, textAlign: "center" }}
                                        onAccept={(val) => this.handleIdClienteAnoChange(val, item.id, ano)}
                                    />

                                    <InputGroup.Text>-</InputGroup.Text>

                                    <Form.Control
                                        as={IMaskInput}
                                        mask="00000(0[0])"
                                        lazy={false}
                                        unmask="typed"
                                        key={`num-${item.id}-${this.onlyDigits(numero)}`}
                                        defaultValue={pendente?.numero ?? this.onlyDigits(numero)}
                                        inputMode="numeric"
                                        autoComplete="off"
                                        disabled={!canEdit}
                                        onAccept={(val) => this.handleIdClienteNumeroChange(val, item.id, numero)}
                                        onKeyDown={(ev) => {
                                        const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'];
                                        if (!/^\d$/.test(ev.key) && !allowed.includes(ev.key)) ev.preventDefault();
                                        }}
                                    />
                                    
                                    {canEdit && hasPending && (
                                        <>
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            title="Confirmar alteração"
                                            onClick={() => this.handleIdClienteConfirm(item.id, ano, numero)}
                                        >
                                            <FaCheck />
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            title="Cancelar alteração"
                                            onClick={() => this.handleIdClienteCancel(item.id)}
                                        >
                                            <FaTimes />
                                        </Button>
                                        </>
                                    )}
                                    </InputGroup>
                                );
                                })()}
                            </td>

                            <td>{formataDataHoraExibicao(item.data)}</td>
                            <td>{item.dados_cadastrado_por.nome} {item.dados_cadastrado_por.sobrenome}</td>
                            <td>{item.farmacovigilancia_data_envio ? formataDataHoraExibicao(item.farmacovigilancia_data_envio) : '-'}</td>
                            <td>
                                {item.dados_atendimento.programa.farmacovigilancia_habilitar_pdf && (
                                    <>
                                        <DropdownButton 
                                            id="dropdown-basic-button" 
                                            title="Opções" 
                                            size="sm" 
                                            variant="light"
                                        >
                                            {item.farmacovigilancia_pdf && (
                                                <Dropdown.Item
                                                    as="button"
                                                    onClick={() => this.handleBaixarPdf(item)}
                                                >
                                                    <FaFileDownload className="me-2" /> Abrir/Baixar PDF
                                                </Dropdown.Item>
                                            )}
                                            {!item.letssign_pdf_farmaco_documento_assinado && (
                                                <Dropdown.Item 
                                                    as="button"
                                                    onClick={() => this.gerarPDF(item.id)}
                                                >
                                                    <FaFilePdf className="me-2" /> Gerar PDF
                                                </Dropdown.Item>
                                            )}
                                            <Dropdown.Item as="button" onClick={() => this.handleShowModalRelato (item)}>
                                                <FaEye className="me-2" /> Visualizar Relato
                                            </Dropdown.Item >
                                            <Dropdown.Item
                                                as="button"
                                                onClick={() => this.handleEnviarPDF(item.id)}
                                            >
                                                <FaPaperPlane className="me-2" /> Enviar à Global
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </>
                                )}
                            </td>
                        </tr>
                    )
                });
            } else {
                return this.state.listRegistros.results.map((item) =>
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{formataDataHoraExibicao(item.data)}</td>
                        <td>{item.dados_cadastrado_por.nome} {item.dados_cadastrado_por.sobrenome}</td>
                        <td>{item.farmacovigilancia_data_envio ? formataDataHoraExibicao(item.farmacovigilancia_data_envio) : '-'}</td>
                        <td>
                            {item.dados_atendimento.programa.farmacovigilancia_habilitar_pdf && (
                                <>
                                {item.farmacovigilancia_pdf ? (
                                    <>
                                        <a href={item.farmacovigilancia_pdf} target="_blank" className="btn btn-sm btn-secondary" rel="noopener noreferrer">
                                            <FaFilePdf /> Ver PDF
                                        </a>
                                        {//botao para ver pdf assinado
                                        (item.letssign_pdf_farmaco_documento_assinado) &&
                                        <a href={item.letssign_pdf_farmaco_documento_assinado} target="_blank" className="btn btn-sm btn-secondary" rel="noopener noreferrer">
                                            <FaFilePdf /> Ver PDF assinado
                                        </a>
                                        }

                                        {
                                        //botão para assinar
                                        (!item.letssign_pdf_farmaco || (item.letssign_pdf_farmaco && item.letssign_pdf_farmaco.erro)) &&
                                        <Button 
                                            variant="secondary" 
                                            size="sm" 
                                            onClick={() => this.assinarPDF(item.id)}
                                        >
                                            <FaFilePdf /> Assinar
                                        </Button>
                                        }

                                        {
                                        //tooltip para exibir um erro na assinatura
                                        (item.letssign_pdf_farmaco && item.letssign_pdf_farmaco.erro) &&
                                        <OverlayTrigger
                                            placement="left"
                                            trigger={['hover', 'focus']}
                                            delay={{ show: 250, hide: 150 }}
                                            overlay={<Tooltip id="tip-erro">Assinatura: {item.letssign_pdf_farmaco.erro}</Tooltip>}
                                            >
                                            <span
                                                className="d-inline-block"
                                                tabIndex={0}
                                                style={{ cursor: 'help' }}
                                            >
                                                <FaExclamationCircle className="text-danger" size={20} />
                                            </span>
                                        </OverlayTrigger>
                                        }

                                        {
                                        //tooltip para exibir que a assinatura esta em andamento
                                        (item.letssign_pdf_farmaco && !item.letssign_pdf_farmaco.erro && !item.letssign_pdf_farmaco_documento_assinado) &&
                                        <OverlayTrigger
                                            placement="left"
                                            trigger={['hover', 'focus']}
                                            delay={{ show: 250, hide: 150 }}
                                            overlay={<Tooltip id="tip-info">A assinatura do documento está em andamento!</Tooltip>}
                                            >
                                            <span
                                                className="d-inline-block"
                                                tabIndex={0}
                                                style={{ cursor: 'help' }}
                                            >
                                                <FaExclamationCircle className="text-info" size={20} />
                                            </span>
                                        </OverlayTrigger>
                                        }

                                        {
                                        //botão para enviar
                                        }
                                        <Button 
                                            variant="light" 
                                            size="sm" 
                                            onClick={() => this.handleEnviarPDF(item.id)}
                                            className="ms-2"
                                        >
                                            <FaPaperPlane className="me-2" /> Enviar Relato
                                        </Button>
                                    </>
                                ) : (
                                <Button 
                                    variant="light" 
                                    size="sm" 
                                    onClick={() => this.gerarPDF(item.id)}
                                >
                                    <FaFilePdf /> Gerar PDF
                                </Button>
                                )}
                                </>
                            )}
                        </td>
                    </tr>
                );
            }
        }        
    
        if(this.state.filtro_status) {
            return (
                <tr>
                    <td colSpan={5}>Nenhum relato de farmacovigilância encontrado</td>
                </tr>
            );
        }
        
    };
    

    filtrarFarmacovigilancia = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistro()
    };

    limparFiltros = () => {
        let startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        let endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        let dados_usuario = getCurrentUser();
        const cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : '';
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_cliente_id: cliente_id,
            filtro_programa_id: programa_id,
            filtro_status: false,

            paciente_nome: '',
            filtro_usuario_relato_id: "",
            filtro_doenca_id: "",
            filtro_usuario_relato_nome: "",
            codigo_externo: "",
            listRegistros: []
        });
    }

    gerarPDF = (relatoId) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Gerando PDF...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        api.post('/atendimentos/relatos/farmacovigilancia/pdf/', { relato_id: relatoId })
            .then((response) => {
                Swal.close();
                
                Swal.fire({
                    title: 'PDF gerado com sucesso!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                this.consultaRegistro();
            })
            .catch((error) => {
                Swal.close();
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro ao gerar PDF',
                    text: 'Não foi possível gerar o PDF. Tente novamente mais tarde.',
                });
            });
    };

    handleAssinarPDFFarmaco = (item) => {
        const assinaturaEmAndamento = item.letssign_pdf_farmaco && !item.letssign_pdf_farmaco.erro;

        if (assinaturaEmAndamento) {
            Swal.fire({
                title: 'Assinatura em andamento',
                text: 'Já existe uma assinatura pendente para este relato. Deseja substituí-la por uma nova com o PDF atual?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, substituir',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.assinarPDF(item.id);
                }
            });
            return;
        }

        this.assinarPDF(item.id);
    };

    assinarPDF = (relatoId) => {
        let dados_usuario = getCurrentUser();

        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Configurando PDF para assinatura digital',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });        

        let dados = { 
            relato_id: relatoId 
        }

        if(dados_usuario.is_superuser){
            dados['pessoa_id'] = dados_usuario.pessoa_id;
        } else if(dados_usuario.tipo_usuario === 'operador'){
            dados['operador_id'] = dados_usuario.operador_id;
        } else if (dados_usuario.tipo_usuario === 'gestor'){
            dados['gestor_id'] = dados_usuario.gestor_id;
        }
    
        api.post('/atendimentos/relatos/farmacovigilancia/pdf/assinar/', dados)
        .then((response) => {
            Swal.close();
            
            Swal.fire({
                title: 'Link de assinatura gerado e enviado por e-mail.',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            this.consultaRegistro();
        })
        .catch((error) => {            
            const dados_response = error.response.data
            let msg_erro = ''            

            if(dados_response.tipo_usuario){
                msg_erro = 'Informe o campo operador_id, gestor_id ou pessoa_id'
            }
            else if(dados_response.operador_id){
                msg_erro = 'O operador_id informado não existe.'
            }
            else if(dados_response.gestor_id){
                msg_erro = 'O gestor_id informado não existe.'
            }
            else if(dados_response.erro){
                msg_erro = dados_response.erro
            }
            else {
                msg_erro = "Não foi possível assinar o PDF. Tente novamente mais tarde."
            }

            Swal.close();
            MySwal.fire({
                icon: 'error',
                title: 'Erro ao gerar link de assinatura do PDF',
                text: msg_erro,
            });

            this.consultaRegistro();
        });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page)
    };

    enviarRelatorioExcel() {
        Swal.fire({
            title: 'Você tem certeza?',
            text: "Deseja enviar o relatório de Excel de Farmacovigilância?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                // Mostra alerta de carregamento
                Swal.fire({
                    title: 'Enviando relatório...',
                    text: 'Por favor, aguarde enquanto o relatório é gerado e enviado.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                
                // Enviando os valores no corpo do post
                api.post('/atendimentos/relatos/farmacovigilancia/gerar/', {
                    programa_id: this.state.filtro_programa_id,
                    data_inicio: this.state.filtro_data_inicio,
                    data_fim: this.state.filtro_data_fim
                })
                .then(response => {
                    Swal.fire({
                        title: 'Relatório enviado com sucesso!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                    this.consultaRegistro();
                })
                .catch(error => {
                    let erro_msg = 'Erro ao enviar o relatório, tente novamente.';
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    } else if (error.response && error.response.status === 403) {
                        erro_msg = 'Você não tem permissão para acessar essa área';
                    }
                    Swal.fire({
                        title: 'Erro!',
                        text: erro_msg,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                });
            }
        });
    }

    baixarRelatorioExcel() {
        // Enviando os valores no corpo do post
        api.post('/atendimentos/relatos/farmacovigilancia/gerar/', {
            programa_id: this.state.filtro_programa_id,
            data_inicio: this.state.filtro_data_inicio,
            data_fim: this.state.filtro_data_fim,
            formato: "download"
        })
        .then(response => {
            window.open(response.data.arquivo_url, '_blank');
        })
        .catch(error => {
            let erro_msg = 'Erro ao bairxar o relatório, tente novamente.';
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 403) {
                erro_msg = 'Você não tem permissão para acessar essa área';
            }
            Swal.fire({
                title: 'Erro!',
                text: erro_msg,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    }

    handleShowModalRelato = (relatoItem) => {
        // se por acaso vier só o valores_list, trata igual antes
        let valores = relatoItem;
        if (typeof relatoItem === 'string') {
            try { valores = JSON.parse(relatoItem); } catch { valores = relatoItem; }
        } else if (relatoItem?.valores_list) {
            valores = relatoItem.valores_list;
        }

        const podeEditarRelato =
            !!(relatoItem?.dados_atendimento?.programa?.farmacovigilancia_habilitar_pdf) &&
            !relatoItem?.letssign_pdf_farmaco_documento_assinado;

        this.setState({
            showModalRelato: true,
            valoresRelato: valores,
            modalRelatoCtx: relatoItem, 
            podeEditarRelato,               
            editingCampoValues: {},         
            campoEditadoValores: {},
            updatingCampoValues: {},
        });
    };

    handleCloseModalRelato = () => {
        this.consultaRegistro();
        this.setState({
            showModalRelato: false,
            valoresRelato: null
        });
    }

    handleShowModalUploadFarmaco = (relatoItem) => {
        this.setState({
            dados_modal_upload: {
                "relato_id": relatoItem.id
            },
            showModalUploadFarmaco: true,            
        });
    };

    handleCloseModalUploadFarmaco = () => {
        this.setState({
            showModalUploadFarmaco: false,
            dados_modal_upload: {}
        });
    }

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            
            this.setState({ arquivo_upload: arquivo_enviado });
        }
    };

    handleOpenModalHistorico = async () => {
        const programaId =
            this.state.filtro_programa_id ||
            getCurrentUser()?.ambiente_programa_id ||
            this.props.programa_id ||
            this.props.programaId;

        this.setState({ showModalHistorico: true, historicoEnvios: [], historicoLoading: true });

        if (!programaId) {
            this.setState({ historicoLoading: false });
            return;
        }

        try {
            const { data } = await api.get(
            "atendimentos/relatos/farmacovigilancia/historico/",
            { params: { programa_id: programaId } }
            );

            const itens = Array.isArray(data)
            ? data
            : (Array.isArray(data?.results) ? data.results : []);

            this.setState({
            historicoEnvios: itens,

            });
        } catch (err) {
            Swal.fire('Erro', 'Não foi possível carregar o histórico.', 'error');
            this.setState({ historicoEnvios: [] });
        } finally {
            this.setState({ historicoLoading: false });
        }
    };

    handleCloseModalHistorico = () => {
        this.setState({
            showModalHistorico: false,
            historicoEnvios: [],
            historicoLoading: false,
        });
    };

    toggleEditCampo = (valorId, currentValue, formularioCampoId) => {
        this.setState(prev => {
        const jaEstaEditandoEste = !!(prev.editingCampoValues && prev.editingCampoValues[valorId]);

            if (jaEstaEditandoEste) {
                return {
                    editingCampoValues: {}, 
                };
            }

            return {
                editingCampoValues: { [valorId]: true },
                campoEditadoValores: {
                    ...(prev.campoEditadoValores || {}),
                    [valorId]: prev.campoEditadoValores?.[valorId] ?? currentValue ?? '',
                },
            };
        }, () => {
            this.fetchCampoMeta(valorId, formularioCampoId);
        });
    };

    fetchCampoMeta = async (valorId, formularioCampoId) => {
        if (!formularioCampoId) return;

        try {
            const { data } = await api.get(`/formularios/campos/${formularioCampoId}/`);
            this.setState(prev => ({
            campoMetaById: { ...(prev.campoMetaById || {}), [valorId]: data },
            }));
        } catch (e) {
            console.error('Falha ao carregar metadado do campo', formularioCampoId, e);
        }
    };

    handleCampoValueChange = (valorId, novoValor) => {
        this.setState(prev => ({ campoEditadoValores: { ...(prev.campoEditadoValores || {}), [valorId]: novoValor }, }));
    };

    saveCampoValor = (campo) => {
        const novoValor = (this.state.campoEditadoValores || {})[campo.id];

        this.setState(prev => ({
            updatingCampoValues: { ...(prev.updatingCampoValues || {}), [campo.id]: true },
        }));

        api.put(`/atendimentos/relatos/valores/${campo.id}/`, {
            valor: novoValor,
            formulario_campo_id: campo.formulario_campo__id,
            relato_id: campo.relato_id,
        })
        .then(() => {
            this.setState(prev => {

            let valoresRelato = prev.valoresRelato;
                if (Array.isArray(valoresRelato)) {
                    valoresRelato = valoresRelato.map(v => {
                    const vid = v.id ?? v.formulario_campo_id;
                    return (vid === campo.id) ? { ...v, valor: novoValor } : v;
                    });
                } else if (valoresRelato && typeof valoresRelato === 'object') {
                }

            let modalRelatoCtx = prev.modalRelatoCtx;
                if (modalRelatoCtx && Array.isArray(modalRelatoCtx.valores_list)) {
                    modalRelatoCtx = {
                    ...modalRelatoCtx,
                    valores_list: modalRelatoCtx.valores_list.map(v =>
                        v.id === campo.id ? { ...v, valor: novoValor } : v
                    ),
                };
            }

            const novosRelatosAtendimento = { ...(prev.relatos_atendimento || {}) };
            Object.entries(novosRelatosAtendimento).forEach(([k, relatos]) => {
                novosRelatosAtendimento[k] = (relatos || []).map(rel => ({
                ...rel,
                valores_list: (rel.valores_list || []).map(v =>
                    v.id === campo.id ? { ...v, valor: novoValor } : v
                ),
                }));
            });

            return {
                valoresRelato,                    
                modalRelatoCtx,
                relatos_atendimento: novosRelatosAtendimento,
                editingCampoValues: { ...(prev.editingCampoValues || {}), [campo.id]: false },
            };
            });
            Swal.fire({ icon: 'success', title: 'Salvo', text: 'Valor atualizado com sucesso' });
        })
        .catch(() => {
            Swal.fire({ icon: 'error', title: 'Falha', text: 'Não foi possível salvar a alteração' });
        })
        .finally(() => {
            this.setState(prev => ({
            updatingCampoValues: { ...(prev.updatingCampoValues || {}), [campo.id]: false },
            }));
        });
    };

    handleBaixarPdf = (item) => {
        // abre em nova aba com noopener
        const win = window.open(item.farmacovigilancia_pdf, "_blank", "noopener");
        if (win) win.opener = null;
    };

    handleEnviarPDF = (relatoId) => {
        Swal.fire({
            title: 'Enviar PDF?',
            text: "Deseja enviar o arquivo PDF deste relato?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (!result.isConfirmed) return;

            // Loading enquanto envia
            Swal.fire({
                title: 'Enviando...',
                text: 'Por favor, aguarde.',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            api.post('/atendimentos/relatos/farmacovigilancia/envio/', {
                relato_id: relatoId
            })
            .then(() => {
                Swal.fire({
                    title: 'Enviado com sucesso!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                // atualiza a listagem, se você já usa isso
                if (typeof this.consultaRegistro === 'function') this.consultaRegistro();
            })
            .catch((error) => {
                let erro_msg = 'Erro ao enviar o relato, tente novamente.';
                const status = error?.response?.status;

                if (status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (status === 403) {
                    erro_msg = 'Você não tem permissão para realizar esta ação';
                } else if (error?.response?.data?.detail) {
                    erro_msg = String(error.response.data.detail);
                }

                Swal.fire({
                    title: 'Erro!',
                    text: erro_msg,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });
        });
    };
    
    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Farmacovigilância</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                                            
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.filtrarFarmacovigilancia}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control type="date" name="filtro_data_inicio" value={this.state.filtro_data_inicio} onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Final</Form.Label>
                                        <Form.Control type="date" name="filtro_data_fim" value={this.state.filtro_data_fim} onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')} />    
                                    </Form.Group>
                                </Col>
                                {dados_usuario['ambiente_cliente_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cliente</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarClientes}
                                            defaultOptions
                                            name="cliente_id"
                                            placeholder="Buscar cliente..."
                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                            value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {(this.state.filtro_programa_id || dados_usuario['ambiente_programa_id']) && (
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do Paciente</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="paciente_nome"
                                                value={this.state.paciente_nome}
                                                onChange={e => this.handleChangeFiltros(e, 'paciente_nome')}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}

                                {(this.state.filtro_programa_id || dados_usuario['ambiente_programa_id']) && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Navegadora</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_usuario_relato_nome"
                                            value={this.state.filtro_usuario_relato_nome}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_usuario_relato_nome')}
                                        />
                                    </Form.Group>
                                    {/*<AsyncSelect          
                                        cacheOptions
                                        loadOptions={this.carregaNavegadora}
                                        defaultOptions
                                        name="usuario_relato_nome"
                                        placeholder={'Buscar navegadora...'}
                                        noOptionsMessage={() => "Nenhuma navegadora encontrada"}
                                        onChange={e => this.handleChangeFiltros(e, 'usuario_relato_nome')}
                                        value={this.state.filtro_usuario_relato_id ? { value: this.state.filtro_usuario_relato_id, label: this.state.filtro_usuario_relato_nome } : null}
                                    />*/}
                                </Col>
                                )}

                                {(this.state.filtro_programa_id || dados_usuario['ambiente_programa_id']) && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Patologia</Form.Label>
                                        <AsyncSelect          
                                            cacheOptions
                                            loadOptions={this.carregaDoencas}
                                            defaultOptions
                                            name="doenca_id"
                                            placeholder={'Buscar doença...'}
                                            noOptionsMessage={() => "Nenhuma doença encontrada"}
                                            onChange={e => this.handleChangeFiltros(e, 'doenca_id')}
                                            value={this.state.filtro_doenca_id ? { value: this.state.filtro_doenca_id, label: this.state.filtro_doenca_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}

                                {(this.state.filtro_programa_id || dados_usuario['ambiente_programa_id']) && (
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                        <Form.Label>Código Externo</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="codigo_externo"
                                                value={this.state.codigo_externo }
                                                onChange={e => this.handleChangeFiltros(e, 'codigo_externo ')}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                            {this.state.filtro_programa_id && (
                            <div className="d-flex justify-content-between">
                                    <Button type="submit" variant="secondary" size="sm">
                                        <FaSearch /> Filtrar
                                    </Button>
                                    <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limparFiltros()}>
                                        <FaEraser /> Limpar filtro
                                    </Button>
                                    {this.state.programa_dados?.habilita_excel_farmacovigilancia && (
                                    <div className="ms-auto">
                                        <Button type="button" size="sm" variant="light" onClick={() => this.enviarRelatorioExcel()}>
                                            <FaFileExcel /> Enviar Excel de Farmacovigilância
                                        </Button>
                                        
                                        <Button type="button" size="sm" variant="light" onClick={this.handleOpenModalHistorico}>
                                            <FaFileExcel /> Histórico de envios
                                        </Button>

                                        <Button type="button" size="sm" variant="light" onClick={() => this.baixarRelatorioExcel()}>
                                            <FaFileExcel /> Baixar Excel de Farmacovigilância
                                        </Button>
                                    </div>
                                    )}
                            </div>
                            )}
                        </Form>

                        <Modal size="xl" show={this.state.showModalRelato} onHide={this.handleCloseModalRelato}>
                            <Modal.Header closeButton>
                                <Modal.Title>Dados do Relato</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {(() => {
                                    const valores = this.state.valoresRelato;
                                    if (!valores) return <p>Nenhum dado disponível.</p>;

                                    const podeEditar = !!this.state.podeEditarRelato;

                                    // normaliza para [{label, value, sessao, ordem}] 
                                    const normalize = (x) => {
                                        if (Array.isArray(x)) {
                                        return x.map((it, idx) => ({
                                            id: it.id ?? it.formulario_campo_id ?? idx, 
                                            arquivo: it.arquivo || '',                 
                                            label:
                                            it.formulario_campo__label ||
                                            it.formulario_campo__nome ||
                                            it.formulario_campo__slug ||
                                            'Campo',
                                            value:
                                            typeof it.valor === 'object'
                                                ? JSON.stringify(it.valor)
                                                : (it.valor ?? '-'),
                                            sessao: it.formulario_campo__sessao || 'Outros dados',
                                            ordem:
                                            typeof it.formulario_campo__ordem === 'number'
                                                ? it.formulario_campo__ordem
                                                : parseFloat(String(it.formulario_campo__ordem || '')) || idx + 1,
                                            // opcional (se você usa no save):
                                            formulario_campo__id: it.formulario_campo__id,
                                            relato_id: it.relato_id,
                                        }));
                                    }
                                    // quando vier como objeto simples, joga tudo numa seção única
                                    return Object.entries(x).map(([k, v], idx) => ({
                                        label: String(k),
                                        value: typeof v === 'object' ? JSON.stringify(v) : (v ?? '-'),
                                        sessao: 'Dados',
                                        ordem: idx + 1,
                                    }));
                                    };

                                    const items = normalize(valores);

                                    items.sort((a, b) => {
                                        const sA = a.sessao || '';
                                        const sB = b.sessao || '';
                                        if (sA !== sB) return sA.localeCompare(sB);
                                        const oA = (typeof a.ordem === 'number' ? a.ordem : Number(a.ordem) || 0);
                                        const oB = (typeof b.ordem === 'number' ? b.ordem : Number(b.ordem) || 0);
                                        return oA - oB;
                                    });

                                    // agrupa por sessão e ordena por ordem dentro de cada uma 
                                    const grupos = items.reduce((acc, it) => {
                                        if (!acc[it.sessao]) acc[it.sessao] = [];
                                        acc[it.sessao].push(it);
                                        return acc;
                                    }, {});

                                    Object.keys(grupos).forEach((s) => {
                                        grupos[s].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
                                    });

                                    // helper para quebrar a cada 2 itens
                                    const chunk2 = (arr) =>
                                    arr.reduce((acc, cur, i) => {
                                        if (i % 2 === 0) acc.push([cur]);
                                        else acc[acc.length - 1].push(cur);
                                        return acc;
                                    }, []);

                                    const prettyTitle = (raw) => {
                                        return tiposSessoesCampos[raw] ? tiposSessoesCampos[raw] : (raw === '0_sem_sessao' ? '' : raw)
                                    };

                                    const CardGrid = ({ title, data, podeEditar }) => (
                                        <div className="card p-3 mb-3">
                                            <h5 className="mb-3">{prettyTitle(title)}</h5>

                                            {chunk2(data).map((pair, idx) => (
                                            <div className="row mb-2" key={idx}>
                                                {pair.map((it) => {
                                                const isEditing = (this.state.editingCampoValues || {})[it.id] === true;
                                                const editedValue = (this.state.campoEditadoValores || {})[it.id] ?? it.value;

                                                return (
                                                    <div className="col-md-6" key={`campo-${it.id}`}>
                                                    <div className="d-flex align-items-center mb-1">
                                                        <strong className="me-2">{it.label}:</strong>
                                                        {podeEditar && it.id != null && !it.arquivo && (
                                                        <FaPencilAlt
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.toggleEditCampo(it.id, it.value, it.formulario_campo__id)}
                                                            title="Editar"
                                                        />
                                                        )}
                                                    </div>
                                                        {it.arquivo ? (
                                                            <Button variant="light" size="sm" className="mb-2" href={it.arquivo} target="_blank" rel="noopener noreferrer" >
                                                                <FaEye className="me-1" /> Ver {it.label}
                                                            </Button>
                                                        ) : isEditing ? (
                                                        <div className="d-flex">
                                                            {(() => {
                                                            const meta = (this.state.campoMetaById || {})[it.id] || null;
                                                            const tipo = (meta?.tipo || '').toLowerCase();
                                                            const options = Array.isArray(meta?.opcoes)
                                                                ? meta.opcoes.map(o =>
                                                                    typeof o === 'string'
                                                                    ? { value: o, label: o }
                                                                    : { value: o.value ?? o, label: o.label ?? String(o.value ?? o) }
                                                                )
                                                                : [];

                                                            if (tipo === 'selecao') {
                                                                return (
                                                                <Form.Select
                                                                    value={editedValue ?? ''}
                                                                    onChange={(e) => this.handleCampoValueChange(it.id, e.target.value)}
                                                                    className="me-2"
                                                                    size="sm"
                                                                    autoFocus
                                                                >
                                                                    <option value="">Selecione...</option>
                                                                    {options.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                    ))}
                                                                </Form.Select>
                                                                );
                                                            }

                                                            if (tipo === 'area_texto') {
                                                                return (
                                                                    <Form.Control as="textarea" rows={3} value={editedValue ?? ''} onChange={(e) => this.handleCampoValueChange(it.id, e.target.value)} className="me-2" size="sm" autoFocus />
                                                                );
                                                            }
                                                            return (
                                                                <Form.Control type="text" value={editedValue ?? ''} onChange={(e) => this.handleCampoValueChange(it.id, e.target.value)} className="me-2" size="sm" autoFocus/>
                                                            );
                                                            })()}

                                                            <Button size="sm" variant="success" disabled={!!this.state.updatingCampoValues[it.id]} onClick={() => this.saveCampoValor(it)} title="Salvar" >
                                                                {this.state.updatingCampoValues[it.id]
                                                                    ? <span className="spinner-border spinner-border-sm" />
                                                                    : <FaCheck />
                                                                }
                                                            </Button>
                                                            <Button size="sm" variant="light" className="ms-1" onClick={() => this.toggleEditCampo(it.id, it.value, it.formulario_campo__id)} title="Cancelar">
                                                                <FaTimes />
                                                            </Button>
                                                        </div>
                                                        ) : (
                                                        <div style={{ whiteSpace: 'pre-wrap' }}>
                                                            {String(it.value).match(/^\d{4}-\d{2}-\d{2}$/)
                                                            ? <p className="mb-0">{formataDataExibicao(it.value)}</p>
                                                            : <p className="mb-0">{it.value === 'true' ? 'Sim' : it.value === 'false' ? 'Não' : it.value}</p>
                                                            }
                                                        </div>
                                                        )}
                                                    </div>
                                                );
                                                })}
                                                {pair.length === 1 && <div className="col-md-6" />}
                                            </div>
                                            ))}
                                        </div>
                                    );

                                    // renderiza 1 card por sessão (ordem alfabética das sessões)
                                    const minOrdem = (sessao) =>
                                        Math.min(...grupos[sessao].map(i =>
                                            typeof i.ordem === 'number' ? i.ordem : Number(i.ordem) || Infinity
                                    ));

                                    // ordena as sessões pelo menor "ordem" que existe dentro dela
                                    const sessoesOrdenadas = Object.keys(grupos).sort((s1, s2) => {
                                        const m1 = minOrdem(s1);
                                        const m2 = minOrdem(s2);
                                        if (m1 !== m2) return m1 - m2;
                                        return s1.localeCompare(s2); // se empatar, ordena pelo nome
                                    });

                                    return (
                                        <div className="d-flex flex-column gap-3">
                                            {sessoesOrdenadas.map((sessao) => (
                                            <CardGrid key={sessao} title={sessao} data={grupos[sessao]} podeEditar={podeEditar} />
                                            ))}
                                        </div>
                                    );
                                })()}
                            </Modal.Body>
                        </Modal>
                        <Modal size="xl" show={this.state.showModalHistorico} onHide={this.handleCloseModalHistorico}>
                            <Modal.Header closeButton>
                            <   Modal.Title>Histórico de envios de relatório</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {this.state.historicoLoading ? (
                                <div className="text-center my-4">
                                    <Spinner animation="border" />
                                </div>
                                ) : this.state.historicoEnvios.length === 0 ? (
                                <Alert variant="light" className="mb-0">
                                    Nenhum envio encontrado para o programa selecionado.
                                </Alert>
                                ) : (
                                <Table striped hover size="sm" className="mb-0">
                                    <thead>
                                    <tr>
                                        <th style={{ width: "260px" }}>Data Envio</th>
                                        <th>Arquivo</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.historicoEnvios.map((item) => (
                                        <tr key={item.id}>
                                        <td>{new Date(item.data_envio).toLocaleString("pt-BR")}</td>
                                        <td>
                                            <a href={item.arquivo_enviado} target="_blank" rel="noopener noreferrer">
                                            Ver Arquivo
                                            </a>
                                        </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                                )}
                            </Modal.Body>
                        </Modal>

                        <Modal size="lg" show={this.state.showModalUploadFarmaco} onHide={this.handleCloseModalUploadFarmaco}>
                            <Modal.Header closeButton>
                                <Modal.Title>Upload de PDF de Farmacovigilancia</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form method="post" onSubmit={this.uplPdfFarmaco}>
                                    <div className="row">
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Arquivo PDF</Form.Label>
                                                <Form.Control 
                                                type="file" 
                                                accept="application/pdf"
                                                name="farmacovigilancia_pdf" 
                                                onChange={this.onChangeArquivo} ref={this.fileInput} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </div>
                                    
                                    <Button 
                                        className="mt-4"
                                        type="submit"
                                        variant="secondary" 
                                    >
                                        Enviar
                                    </Button>
                                </Form>                                
                            </Modal.Body>
                        </Modal>

                        {this.state.programa_dados?.farmacovigilancia_modelo === 'ache' ? (
                            <>
                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Criado Por</th>
                                            <th>Data Recebimento Relato</th>
                                            <th>Data Envio</th>
                                            <th>Produto</th>
                                            <th>Protocolo Atendimento (ServiceCloud)</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading ? (
                                        <tr>
                                            <td colSpan={7}>Carregando...</td>
                                        </tr>
                                        ) : (
                                            this.state.error ? (
                                                <tr>
                                                    <td colSpan={7}>{this.state.error}</td>
                                                </tr>
                                            ) : this.renderRows()
                                        )}                                           
                                    </tbody>
                                </Table>
                            </>
                        ) : this.state.programa_dados?.farmacovigilancia_modelo === 'psp_compass' ? (
                            <>
                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>N° do Relato Local</th>
                                            <th>Atendimento</th>
                                            <th>Protocolo de atendimento Chiesi</th>
                                            <th>Data Relato</th>
                                            <th>Data Envio</th>
                                            <th>Produto</th>
                                            <th>Iniciais Paciente</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading ? (
                                        <tr>
                                            <td colSpan={7}>Carregando...</td>
                                        </tr>
                                        ) : (
                                            this.state.error ? (
                                                <tr>
                                                    <td colSpan={7}>{this.state.error}</td>
                                                </tr>
                                            ) : this.renderRows()
                                        )}                                           
                                    </tbody>
                                </Table>
                            </>
                        ) : this.state.programa_dados?.farmacovigilancia_modelo === 'ultracare' ? (
                            <>
                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome Paciente</th>
                                            <th>Patologia</th>
                                            <th>Código de Envio</th>
                                            <th>Data</th>
                                            <th>Criado Por</th>
                                            <th>Data Envio</th>
                                            <th></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading ? (
                                        <tr>
                                            <td colSpan={7}>Carregando...</td>
                                        </tr>
                                        ) : (
                                            this.state.error ? (
                                                <tr>
                                                    <td colSpan={7}>{this.state.error}</td>
                                                </tr>
                                            ) : this.renderRows()
                                        )}                                           
                                    </tbody>
                                </Table>
                            </>
                        ) : (
                            <Table responsive className="custom-table mt-3">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Data</th>
                                        <th>Criado Por</th>
                                        <th>Data Envio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading ? (
                                    <tr>
                                        <td colSpan={5}>Carregando...</td>
                                    </tr>
                                    ) : (
                                        this.state.error ? (
                                            <tr>
                                                <td colSpan={5}>{this.state.error}</td>
                                            </tr>
                                        ) : this.renderRows()
                                    )}                                           
                                </tbody>
                            </Table>
                        )}
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                                         
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Farmacovigilancia);